import React from 'react'
import styled from 'styled-components'

export const FormGroup = styled.div`
    margin-bottom: 1.6rem;
`